import React, { useState } from 'react'
import { Skeleton, } from "@chakra-ui/react"

export default function CauseImage(props) {
    const [isloaded, imageLoad] = useState(false);
    const imageStyle = !isloaded ? { display: "none" } : {};
    const placeholder = !isloaded ?<Skeleton height="30vh" width="100%"  />:null
    return (
        <>
        {placeholder}
        <img src={props.image} alt={props.title} style={imageStyle} onLoad={imageLoad}/>
        </>
    )
}
